export default __webpack_public_path__ + "static/media/DownArrow.3a855c86.svg";